/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery, useMutation } from '@apollo/client';
import { DeleteIcon, InfoIcon, TimeIcon } from '@chakra-ui/icons';
import {
	Accordion,
	AccordionButton,
	AccordionIcon,
	AccordionItem,
	AccordionPanel,
	AlertDialog,
	AlertDialogBody,
	AlertDialogContent,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogOverlay,
	Avatar,
	Badge,
	Box,
	Button,
	Center,
	Container,
	Flex,
	HStack,
	Image,
	Menu,
	MenuButton,
	MenuDivider,
	MenuItem,
	MenuList,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalOverlay,
	Popover,
	PopoverArrow,
	PopoverBody,
	PopoverContent,
	PopoverTrigger,
	Select,
	SimpleGrid,
	Tab,
	TabList,
	TabPanel,
	TabPanels,
	Tabs,
	Td,
	Text,
	Tooltip,
	Tr,
	useDisclosure,
	useToast,
	Wrap,
	WrapItem,
} from '@chakra-ui/react';
import { faEllipsisH, faEye, faFileSignature, faMinusSquare, faPlusSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaChevronDown, FaLink } from 'react-icons/fa';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { v4 as uuidv4 } from 'uuid';
import ViewComment from '../../components/Comment/ViewComment';
import SmallDownloadAndViewButton from '../../components/Files/SmallDownloadAndViewButton';
import LabelDate from '../../components/LabelDate';
import LabelDetail from '../../components/LabelDetail';
import LoadingOverlay from '../../components/LoadingOverlay/LoadingOverlay';
import SelectUserAllModal from '../../components/Modal/SelectUserShowAllModal';
import DepartmentUserAssign from '../../components/UserAssign/DepartmentUserAssign';
import OfficeUserAssign from '../../components/UserAssign/OfficeUserAssign';
import UserDislayNameById from '../../components/UserDislayNameById';
import c from '../../constant';
import useStore from '../../store';
import { isUserPermitted } from '../../utils/checker';
import getDepartmentLabel from '../../utils/getDepartmentLabel';
import getOfficeLabel from '../../utils/getOfficeLabel';
import { isAdmin, isAssistant } from '../../utils/role';
import ProposalDetailModal from '../CompanySubmissionProposal/detailModal';
import DoneFile from './components/DoneFile';
import NPEditor from './components/np-editor';
import Print from './components/print';
import ProposalNumberLink from './components/ProposalNumberLink';
import Relation from './components/Relation';
import RelationDeletion from './components/RelationDeletion';
import SignMiscModal from './components/SignMiscModal';
import SignNpModal from './components/SignNpModal';
import StepBackModal from './components/StepBackModal';
import TagViewer from './components/TagViewer';
import './style.css';
import {
	canChangeDepartment,
	canChangeOffice,
	enableNpStepChange,
	getBackwardStepsByPosition,
	getForwardStepsByPosition,
	hideDepartmentSelectionPlaceholder,
	hideOfficeSelectionPlaceholder,
	npMappingStep as mappingStep,
	npDeptSigningFlows,
	npSigningFlows,
	rpDeptSigningFlows,
	rpSigningFlows,
	timeLineActions,
} from './utils';

const LABEL_WIDTH = '169px';
const rp = 'rp';
const np = 'np';
const stepDepartment = 'department';
const stepDg = 'dg';
const stepFsa = 'fsa';
const stepDone = 'done';
const mappingType = { np: 'Note of Presentation', rp: 'Report' };
const mappingPosition = { Officials: 1, Office: 2, Department: 3, 'Deputy Director General': 4, 'Director General': 6 };

function NpReferenceDetailModal({ id, onCloseModal }) {
	const toast = useToast();
	const modalDeleteNp = useDisclosure();
	const detailModal = useDisclosure();
	const { push } = useHistory();
	const { t } = useTranslation();
	const { currentLang } = useStore((state) => state.currentLang);
	const { currentUser: user } = useStore((state) => state.currentUser);
	const [npSigns, setNpSigns] = useState(null);
	const [tempSignPosition, setTempSignPosition] = useState(null);
	const [activeSignData, setActiveSignData] = useState(null);
	const [activeSignDataMisc, setActiveSignDataMisc] = useState(null);
	const [stepBack, setStepBack] = useState(null);
	const [npData, setNpData] = useState(null);
	const [type, setType] = useState(null);
	const [openSelectUserAllModel, setOpenSelectUserAllModel] = useState(false);
	const [defaultTabIndex, setDefaultTabIndex] = useState(0);
	const [isSetNpColor, setSetNpColor] = useState(false);
	const [isShowingDoneFile, setShowingDoneFile] = useState(false);
	const [removeSignNp, { loading: loadingRemoveSignNp, error: errorRemoveSignNp, data: dataRemoveSignNp }] = useMutation(REMOVE_SIGN_NP_MUTATION);
	const [removeReviewer, { loading: loadingRemoveReviewer, error: errorRemoveReviewer, data: dataRemoveReviewer }] = useMutation(REMOVE_REVIEWER_MUTATION);
	const [loadNpSignsData, { loading: loadingNpSigns, data: dataGetNpSigns }] = useLazyQuery(GET_NP_SIGNS);
	const [assignNpSign, { loading: loadingAssignNpSign }] = useMutation(ASSIGN_NP_SIGN_MUTATION);
	const [removeSignNpMisc, { loading: loadingRemoveSignNpMisc }] = useMutation(REMOVE_SIGNNP_MISC_MUTATION);
	const [loadData, { loading, data }] = useLazyQuery(Q_GET_REQUESTS);
	const [deleteNp, { loading: loadingDeleteNp }] = useMutation(M_DELETE_NP);
	const [urgentNp, { loading: loadingUrgentNp }] = useMutation(M_URGENT_NP);
	const [setNpColor, { loading: loadingAssistantColorNp }] = useMutation(M_A_COLOR_NP);
	const [createNpRelation, { loading: loadingNpRelation }] = useMutation(M_CREATE_RELATION);
	const [appendDepartmentToNpRelation, { loading: loadingAddDeptRelation }] = useMutation(M_ADD_DEPARTMENT_RELATION);
	const [removeDepartmentFromNpRelation, { loading: loadingRemoveDeptRelation }] = useMutation(M_REMOVE_DEPARTMENT_RELATION);
	const [appendOfficeToNpRelation, { loading: loadingAddOfficeRelation }] = useMutation(M_ADD_OFFICE_RELATION);
	const [removeOfficeFromNpRelation, { loading: loadingRemoveOfficeRelation }] = useMutation(M_REMOVE_OFFICE_RELATION);

	useEffect(() => {
		const isAllowedStep = [stepDg, stepFsa, stepDone]?.includes(npData?.step);
		const isDeparmentLevelAllowedStep = npData?.isDepartmentLevel && (npData?.step === stepDepartment || npData?.step === stepDone);
		const isDoneFileExist = npData?.doneFile?.file;
		setShowingDoneFile(isAllowedStep || isDeparmentLevelAllowedStep || isDoneFileExist);
	}, [npData]);

	const signs = useMemo(() => {
		let localSigners = npSigns
			?.map((npSign) => npSign?.data)
			?.reduce((pre, cur, i) => {
				let localPre = pre;
				if (cur?.decisionAt) {
					localPre.push(cur);
				}
				return localPre;
			}, [])
			?.sort((a, b) => new Date(a?.decisionAt) - new Date(b?.decisionAt));
		return localSigners;
	}, [npSigns]);

	useEffect(() => id && setDefaultTabIndex(0), [id]);

	useEffect(() => {
		if (user) {
			const role = user?.role || '';
			const roles = role?.split(',');
			setSetNpColor(roles?.includes('admin') || (roles?.includes('nprp') && isUserPermitted(['nprpSetColor'], ...(user?.nprp ?? []))));
		}
	}, [user]);

	moment.locale(currentLang === 'kh' ? 'km' : 'en-gb');

	useEffect(() => {
		dataRemoveSignNp?.removeSignNp && loadNp();
	}, [dataRemoveSignNp]);

	useEffect(() => {
		dataRemoveReviewer?.removeReviewer && loadNp();
	}, [dataRemoveReviewer]);

	useEffect(() => {
		if (dataGetNpSigns?.getNpSigns) {
			const tempList = generateNpSigns(dataGetNpSigns?.getNpSigns);
			setNpSigns(tempList);
		}
	}, [dataGetNpSigns]);

	function generateNpSigns(npSignData) {
		let list = [];
		let positions =
			type === rp
				? data?.getNpById?.isDepartmentLevel
					? rpDeptSigningFlows
					: rpSigningFlows
				: data?.getNpById?.isDepartmentLevel
					? npDeptSigningFlows
					: npSigningFlows;
		positions.forEach((item) => {
			const signData = getSignDataByPosition(item, npSignData);
			list.push({
				position: item,
				data: signData || null,
			});
		});
		return list;
	}

	function getSignDataByPosition(position, npSigns) {
		let signDetail = npSigns?.filter((e) => e?.position === position);
		return signDetail?.[0] || null;
	}

	const [changeOfficeMutation, { loading: loadingChangeOffice, error: errorChangeOffice, data: dataChangeOffice }] = useMutation(CHANGE_OFFICE_MUTATION);

	useEffect(() => {
		if (dataChangeOffice?.changeNpOffice) {
			setNpData(dataChangeOffice?.changeNpOffice);
		}
	}, [dataChangeOffice]);

	const [changeDepartmentMutation, { loading: loadingChangeDepartment, error: errorChangeDepartment, data: dataChangeDepartment }] =
		useMutation(CHANGE_DEPARTMENT_MUTATION);

	useEffect(() => {
		if (dataChangeDepartment?.changeNpDepartment) {
			setNpData(dataChangeDepartment?.changeNpDepartment);
		}
	}, [dataChangeDepartment]);

	const [changeStepMutation, { loading: loadingChangeStep }] = useMutation(CHANGE_STEP_MUTATION);

	useEffect(() => {
		if (errorChangeDepartment || errorChangeOffice || errorRemoveReviewer || errorRemoveSignNp) {
			let error = null;
			if (errorChangeDepartment) {
				error = errorChangeDepartment;
			}
			if (errorChangeOffice) {
				error = errorChangeOffice;
			}
			if (errorRemoveReviewer) {
				error = errorRemoveReviewer;
				loadNp();
			}
			if (errorRemoveSignNp) {
				error = errorRemoveSignNp;
			}

			if (error) {
				loadData({ variables: { id } });
				if (error?.graphQLErrors?.length > 0) {
					error?.graphQLErrors.map(({ message }, i) =>
						toast({
							title: t(message),
							status: message === 'VIEWER_EXISTED' ? 'warning' : 'error',
							isClosable: true,
							position: 'bottom-right',
						}),
					);
				} else {
					toast({
						title: t(error?.message ? error?.message : 'something went wrong'),
						status: 'error',
						isClosable: true,
						position: 'bottom-right',
					});
				}
			}
		}
	}, [errorChangeDepartment, errorRemoveReviewer, errorRemoveSignNp]);

	const [addViewerMutation, { loading: loadingAddViewer, error: errorAddViewer, data: dataAddViewer }] = useMutation(ADD_VIEWER_MUTATION);

	useEffect(() => {
		if (dataAddViewer?.assignViewerToNp) {
			let tempNp = {
				...npData,
				viewers: [...npData?.viewers, dataAddViewer?.assignViewerToNp],
				timelines: [
					{
						id: uuidv4(),
						createdAt: dataAddViewer?.assignViewerToNp?.createdAt,
						user,
						action: '2',
						description: dataAddViewer?.assignViewerToNp?.userViewer?.username,
					},
					...npData?.timelines,
				],
			};
			setNpData(tempNp);
		}
	}, [dataAddViewer]);

	useEffect(() => {
		if (errorAddViewer) {
			const error = errorAddViewer;
			if (error) {
				if (error?.graphQLErrors?.length > 0) {
					error?.graphQLErrors.map(({ message }, i) =>
						toast({
							title: t(message),
							status: 'error',
							isClosable: true,
							position: 'bottom-right',
						}),
					);
				} else {
					toast({
						title: t(error?.message ? error?.message : 'something went wrong'),
						status: 'error',
						isClosable: true,
						position: 'bottom-right',
					});
				}
			}
		}
	}, [errorAddViewer]);

	const [removeViewerMutation, { loading: loadingRemoveViewer, error: errorRemoveViewer, data: dataRemoveViewer }] = useMutation(REMOVE_VIEWER_MUTATION);

	useEffect(() => {
		if (dataRemoveViewer?.removeViewerFromNp) {
			let tempViewerList = [];
			npData?.viewers?.forEach((item) => {
				if (item?.userViewer?.username !== dataRemoveViewer?.removeViewerFromNp) {
					tempViewerList.push(item);
				}
			});
			let tempNp = {
				...npData,
				viewers: tempViewerList,
				timelines: [
					{
						id: uuidv4(),
						createdAt: moment(),
						user,
						action: '3',
						description: dataRemoveViewer?.removeViewerFromNp,
					},
					...npData?.timelines,
				],
			};
			setNpData(tempNp);
		}
	}, [dataRemoveViewer]);

	useEffect(() => {
		if (errorRemoveViewer) {
			const error = errorRemoveViewer;
			if (error) {
				if (error?.graphQLErrors?.length > 0) {
					error?.graphQLErrors.map(({ message }, i) =>
						toast({
							title: t(message),
							status: 'error',
							isClosable: true,
							position: 'bottom-right',
						}),
					);
				} else {
					toast({
						title: t(error?.message ? error?.message : 'something went wrong'),
						status: 'error',
						isClosable: true,
						position: 'bottom-right',
					});
				}
			}
		}
	}, [errorAddViewer]);

	useEffect(loadNp, [id]);

	useEffect(() => {
		if (data?.getNpById) {
			setNpData(data?.getNpById);
			setType(data?.getNpById?.type);
			loadNpSigns();
		}
	}, [data]);

	function loadNp() {
		loadData({ variables: { id } });
	}

	function loadNpSigns() {
		loadNpSignsData({ variables: { id } });
	}

	function getActionDetail(action) {
		let actionData = timeLineActions?.filter((e) => e?.action === action?.action);
		actionData = actionData[0];
		let desc = '';
		switch (action?.action) {
			case '4': // change step
				try {
					const { step, comments } = JSON.parse(action?.description);
					const description = comments ? ' (' + t('comments') + ': ' + comments + ')' : '';
					desc = t(step) + description;
				} catch (e) {
					desc = t(action?.description);
				}
				break;
			case '5': // change department
				desc = t(getDepartmentLabel(action?.description));
				break;
			case '6': // change office
				desc = getOfficeLabel(action?.description, currentLang);
				break;
			case '7': // request reviewer
				const temp = JSON.parse(action?.description);
				desc = `${temp?.reviewer?.username} (${t(temp?.position)})`;
				break;
			case '8': // remove reviewer
				const temp1 = JSON.parse(action?.description);
				desc = `${temp1?.reviewer?.username} (${t(temp1?.position)})`;
				break;
			case '13':
				desc = ``;
				break;
			case '14':
				const temp2 = JSON.parse(action?.description);
				desc = temp2?.status ? 'TRUE' : 'FALSE';
				break;
			case '15':
				desc = ``;
				break;
			case '16':
				desc = ``;
				break;
			case '17':
				desc = ``;
				break;
			case '18':
				const temp3 = JSON.parse(action?.description);
				desc = temp3?.urgent ? 'TRUE' : 'FALSE';
				break;
			default:
				desc = t(action?.description);
				break;
		}
		return (
			<>
				{currentLang === 'kh' ? actionData?.labelKh : actionData?.labelEn} &nbsp;
				<span style={{ color: '#d35400' }}>{desc}</span>
			</>
		);
	}

	function getOfficeByDepartment(department) {
		let office = [];
		c.departments?.forEach((item) => {
			if (item?.value === department) {
				office = item?.offices;
			}
		});
		return office;
	}

	function labelReviewer(type, position) {
		if (type === np) {
			const pos = mappingPosition[position];
			if (pos === 4) {
				return 'Reviewer';
			} else {
				return 'Approver';
			}
		} else {
			if (signs?.length > 0) {
				const pos = mappingPosition[position];
				if (mappingPosition[signs[0]?.position] < pos) {
					if (pos === 4) {
						return 'Reviewer';
					} else {
						return 'Approver';
					}
				} else if (mappingPosition[signs[0]?.position] > pos) {
					return '-';
				} else {
					return 'Report Preparer';
				}
			} else {
				return '-';
			}
		}
	}

	function reportRoleOut(position) {
		if (signs?.length > 0) {
			if (mappingPosition[signs[0]?.position] < mappingPosition[position]) {
				return false;
			} else if (mappingPosition[signs[0]?.position] > mappingPosition[position]) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	}

	function canComment(position) {
		if (signs?.length > 0) {
			if (mappingPosition[signs[0]?.position] < mappingPosition[position]) {
				return true;
			} else if (mappingPosition[signs[0]?.position] > mappingPosition[position]) {
				return false;
			} else {
				return false;
			}
		} else {
			return false;
		}
	}

	function canDelegate(position) {
		return [1, 4]?.includes(mappingPosition[position]) ? false : true;
	}

	function getLabelComment(position) {
		return [4]?.includes(mappingPosition[position]) ? 'Comment' : 'Approval';
	}

	function canRemoveReviewer(createdById, reviewerId, decisionAt, miscellaneous, position) {
		const step = npData?.step;
		if (
			(mappingStep[step] === mappingPosition[position] || mappingStep[step] < mappingPosition[position]) &&
			((user?.id === createdById && !decisionAt && !miscellaneous) || user?.id === reviewerId || user?.role === 'admin')
		) {
			return true;
		}
		return false;
	}

	function canRemoveSigning(reviewerId, position) {
		const step = npData?.step;
		if (
			(mappingStep[step] === mappingPosition[position] || mappingStep[step] < mappingPosition[position]) &&
			(user?.id === reviewerId || user?.role === 'admin')
		) {
			return true;
		}
		return false;
	}

	function canRemoveMiscellaneous(reviewerId, createdBy, position) {
		const step = npData?.step;
		if (
			(mappingStep[step] === mappingPosition[position] || mappingStep[step] < mappingPosition[position]) &&
			(user?.id === createdBy || user?.id === reviewerId || user?.role === 'admin')
		) {
			return true;
		}
		return false;
	}

	const enableStepChange = useMemo(() => enableNpStepChange({ np: npData, user }), [npData, user]);

	const enableDepartmentChange = useMemo(() => canChangeDepartment({ np: npData, user }), [npData, user]);

	const enableOfficeChange = useMemo(() => canChangeOffice({ np: npData, user }), [npData, user]);

	const hidePlaceholderOffice = useMemo(() => hideOfficeSelectionPlaceholder({ np: npData, user }), [user, npData]);

	const hidePlaceholderDepartment = useMemo(() => hideDepartmentSelectionPlaceholder({ np: npData, user }), [user, npData]);

	function onChangeStep({ selecteStep = null }) {
		const step = mappingStep[npData?.step];
		const changeStep = mappingStep[selecteStep];
		if (changeStep < step) {
			const backwardSteps = getBackwardStepsByPosition({ user, np: npData });
			if (backwardSteps?.includes(changeStep)) {
				setStepBack(selecteStep);
			} else {
				toast({
					title: t('You are not allowed to change to this step'),
					status: 'error',
					isClosable: true,
					position: 'bottom-right',
				});
			}
		} else {
			const forwardSteps = getForwardStepsByPosition({ user, np: npData });
			if (forwardSteps?.includes(changeStep)) {
				changeStepMutation({ variables: { npId: id, step: selecteStep } })
					.then(({ data }) => {
						setNpData(data?.changeNpStep);
						toast({
							title: t('Step has been changed successfully'),
							status: 'success',
							isClosable: true,
							position: 'top-right',
						});
					})
					.catch((error) => {
						toast({
							title: t(error?.message ? error?.message : 'something went wrong'),
							status: 'error',
							isClosable: true,
							position: 'bottom-right',
						});
					});
			} else {
				toast({
					title: t('You are not allowed to change to this step'),
					status: 'error',
					isClosable: true,
					position: 'bottom-right',
				});
			}
		}
	}

	function StepTip() {
		const stepTipModal = useDisclosure();

		return (
			<Popover size="sm" isOpen={stepTipModal?.isOpen} onClose={stepTipModal?.onClose} placement="auto">
				<PopoverTrigger>
					<InfoIcon color="gray.400" boxSize="14px" onClick={stepTipModal?.onOpen} />
				</PopoverTrigger>
				<PopoverContent _focus={{ boxShadow: 'none', outline: 'none' }}>
					<PopoverArrow />
					<PopoverBody>
						<Text fontSize="sm" fontWeight="600" color="gray.600">
							ពណ៌នា៖
						</Text>
						<Text fontSize="sm" fontWeight="400" color="gray.600">
							ការផ្លាស់ប្តូរដំណាក់កាលរបស់កំណត់បង្ហាញ ឬរបាយការណ៍ត្រូវធ្វើតាម &nbsp;
							<span style={{ fontWeight: 'bold' }}>ឋានានុក្រម</span> មិនអាចរំលងបានទេ។ នៅពេលដំណាក់កាលត្រូវបានផ្លាស់ប្តូររួចហើយ
							មិនអាចប្តូរមកវិញបានទេ។
						</Text>
					</PopoverBody>
				</PopoverContent>
			</Popover>
		);
	}

	function DoneFileTip() {
		const doneFileTipModal = useDisclosure();

		return (
			<Popover size="sm" isOpen={doneFileTipModal?.isOpen} onClose={doneFileTipModal?.onClose} placement="auto">
				<PopoverTrigger>
					<InfoIcon color="gray.400" boxSize="14px" onClick={doneFileTipModal?.onOpen} />
				</PopoverTrigger>
				<PopoverContent _focus={{ boxShadow: 'none', outline: 'none' }}>
					<PopoverArrow />
					<PopoverBody>
						<Text fontSize="sm" fontWeight="600" color="gray.600">
							ពណ៌នា៖
						</Text>
						<Text fontSize="sm" fontWeight="400" color="gray.600">
							ការបញ្ចូលឯកសារសម្រេចអាចធ្វើទៅបានលុះត្រាកំណត់បង្ហាញរឿង ឬរបាយការណ៍ស្ថិតនៅដំណាក់កាល{' '}
							<span style={{ fontWeight: 'bold' }}>អគ្គនាយក</span> ឬ<span style={{ fontWeight: 'bold' }}>អ.ស.ហ.</span> និងដំណាក់កាល{' '}
							<span style={{ fontWeight: 'bold' }}>នាយកដ្ឋាន</span> សម្រាប់ការផ្តល់យោបល់។ អ្នកដែលមានសិទិ្ធបញ្ចូល ឬលុបឯកសារសម្រេចគឺ{' '}
							<span style={{ fontWeight: 'bold' }}>អ្នកគ្រប់គ្រង</span> និង
							<span style={{ fontWeight: 'bold' }}>ជំនួយការ</span>។
						</Text>
					</PopoverBody>
				</PopoverContent>
			</Popover>
		);
	}

	return (
		<>
			<Modal scrollBehavior="inside" size="5xl" isOpen={true} onClose={onCloseModal}>
				<ModalOverlay backdropFilter="auto" bg="blackAlpha.300" backdropBlur="2px" />
				<ModalContent borderRadius={c.borderRadius} p="4">
					<Flex justifyContent="flex-end">
						<ModalCloseButton />
						<Button
							size="sm"
							onMouseDown={() => push(`/note-of-presentation/detail?id=${id}&type=${type}`)}
							borderRadius={c.borderRadius}
							mr="10"
							mt="-2"
						>
							{t('Open Full Page')}
						</Button>
					</Flex>
					<ModalBody>
						<>
							{(loading ||
								loadingChangeStep ||
								loadingChangeDepartment ||
								loadingChangeOffice ||
								loadingNpSigns ||
								loadingAssignNpSign ||
								loadingRemoveViewer ||
								loadingRemoveReviewer ||
								loadingRemoveSignNp ||
								loadingRemoveSignNpMisc ||
								loadingDeleteNp ||
								loadingUrgentNp ||
								loadingAssistantColorNp ||
								loadingNpRelation ||
								loadingAddDeptRelation ||
								loadingRemoveDeptRelation ||
								loadingAddOfficeRelation ||
								loadingRemoveOfficeRelation) && (
								<>
									<LoadingOverlay />
								</>
							)}
							<Container maxW="container.xl" mt="16px" mb="16px">
								<Center className="hidden-print" mt="5">
									<Box
										w="100%"
										bg="white"
										borderRadius={c.borderRadius}
										border={npData?.urgent === true ? '1px solid #f87171' : '1px solid #dbdbdb'}
										boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
										pb="16px"
									>
										<Flex
											alignItems="center"
											justifyContent="space-between"
											bg={npData?.urgent === true ? 'red.400' : '#FAFAFA'}
											p="16px"
											pt="8px"
											pb="8px"
											mb="16px"
											borderBottom={npData?.urgent === true ? '1px solid #f87171' : '1px solid #dbdbdb'}
										>
											<Flex w="100%" justifyContent="flex-start" alignItems="center">
												<Text fontSize="x-large" fontWeight="bold" color={npData?.urgent === true ? 'white' : '#303030'}>
													{t('Detail')}
												</Text>
												<>
													{npData?.urgent === true && (
														<>
															<Text fontSize="x-large" fontWeight="bold" color="white" ml={1}>
																({t('Urgency')})
															</Text>
														</>
													)}
												</>
											</Flex>
											<Flex justifyContent="space-between" alignItems="center">
												<Menu>
													<MenuButton cursor="pointer">
														<Button
															colorScheme="gray"
															variant="solid"
															size="sm"
															borderRadius={c.borderRadius}
															border="1px solid #bdc3c7"
														>
															<FontAwesomeIcon icon={faEllipsisH} style={{ fontSize: 16 }} />
														</Button>
													</MenuButton>
													<MenuList pt="4" pb="4" pl="3" pr="3" borderRadius={c.borderRadius}>
														{npData?.urgent === false && (
															<MenuItem
																icon={<TimeIcon />}
																color="orange"
																onClick={() => {
																	urgentNp({ variables: { npId: id, urgent: true } })
																		.then(({ data }) => setNpData(data?.setNpUrgent))
																		.catch((error) => {
																			toast({
																				title: t(error?.message ? error?.message : 'something went wrong'),
																				status: 'error',
																				isClosable: true,
																				position: 'bottom-right',
																			});
																		});
																}}
															>
																{t('Put In Urgency')}
															</MenuItem>
														)}
														{npData?.urgent === true && (
															<MenuItem
																icon={<TimeIcon />}
																color="red"
																onClick={() => {
																	urgentNp({ variables: { npId: id, urgent: false } })
																		.then(({ data }) => setNpData(data?.setNpUrgent))
																		.catch((error) => {
																			toast({
																				title: t(error?.message ? error?.message : 'something went wrong'),
																				status: 'error',
																				isClosable: true,
																				position: 'bottom-right',
																			});
																		});
																}}
															>
																{t('Remove From Urgency')}
															</MenuItem>
														)}
														{((mappingStep[npData?.step] === 1 && npData?.createdBy === user?.id) || user?.role === 'admin') && (
															<MenuItem icon={<DeleteIcon />} color="red" onClick={modalDeleteNp?.onOpen}>
																{t('Delete')}
															</MenuItem>
														)}
														{isSetNpColor && (
															<>
																<MenuDivider />
																{['#303030', '#2ecc71', '#3498db', '#e74c3c'].map((item) => {
																	return (
																		<MenuItem
																			icon={<Box w="16px" h="16px" bg={item} borderRadius="50%"></Box>}
																			onClick={() => {
																				setNpColor({ variables: { npId: id, color: item } })
																					.then(({ data }) => setNpData(data?.setNpColor))
																					.catch((error) => {
																						toast({
																							title: t(error?.message ? error?.message : 'something went wrong'),
																							status: 'error',
																							isClosable: true,
																							position: 'bottom-right',
																						});
																					});
																			}}
																		>
																			{npData?.assistantColor === item && '✓'}
																		</MenuItem>
																	);
																})}
															</>
														)}
													</MenuList>
												</Menu>
											</Flex>
										</Flex>
										<Box p="16px" pt="8px" pb="8px" mb="16px">
											{npData && (
												<>
													<SimpleGrid columns={[1, null, 2]} spacingX={8}>
														<LabelDetail
															mb={1}
															mt={0}
															labelWidth={LABEL_WIDTH}
															direction="row"
															label="Number"
															childDetail={
																<Text color={isSetNpColor && npData?.assistantColor ? npData?.assistantColor : ''}>
																	{npData?.number || 'N/A'}
																</Text>
															}
														/>
														<LabelDetail
															mb={1}
															mt={0}
															labelWidth={LABEL_WIDTH}
															direction="row"
															label="Step"
															childDetail={
																<Select
																	size="sm"
																	value={npData?.step}
																	onChange={(e) => onChangeStep({ selecteStep: e?.currentTarget?.value })}
																	isDisabled={enableStepChange ? false : true}
																>
																	<option value="draft">{t('Draft')}</option>
																	<option value="office">{t('Office')}</option>
																	<option value="department">{t('Department')}</option>
																	{false === npData?.isDepartmentLevel && (
																		<option value="ddg">{t('Deputy Director General')}</option>
																	)}
																	{false === npData?.isDepartmentLevel && <option value="dg">{t('Director General')}</option>}
																	{false === npData?.isDepartmentLevel && <option value="fsa">{t('FSA')}</option>}
																	<option value="done">{t('Done')}</option>
																</Select>
															}
															guide={<StepTip />}
														/>
														<LabelDetail
															mb={1}
															mt={0}
															labelWidth={LABEL_WIDTH}
															direction="row"
															label="Department"
															childDetail={
																<Select
																	size="sm"
																	value={npData?.department || 'na'}
																	onChange={(e) => {
																		changeDepartmentMutation({
																			variables: {
																				npId: id,
																				department: e?.currentTarget?.value,
																			},
																		});
																	}}
																	isDisabled={enableDepartmentChange ? false : true}
																>
																	{false === hidePlaceholderDepartment && (
																		<option key="na" value="na">
																			N/A
																		</option>
																	)}
																	{c.departments.map((item, index) => {
																		return (
																			<option key={index} value={item?.value}>
																				{currentLang === 'kh' ? item?.labelKh : item?.label}
																			</option>
																		);
																	})}
																</Select>
															}
														/>
														<LabelDetail
															mb={1}
															mt={0}
															labelWidth={LABEL_WIDTH}
															direction="row"
															label="Office"
															childDetail={
																<Select
																	size="sm"
																	value={npData?.office || 'na'}
																	onChange={(e) => {
																		changeOfficeMutation({
																			variables: {
																				npId: id,
																				office: e?.currentTarget?.value,
																			},
																		});
																	}}
																	isDisabled={enableOfficeChange ? false : true}
																>
																	{false === hidePlaceholderOffice && (
																		<option key="na" value="na">
																			N/A
																		</option>
																	)}
																	{getOfficeByDepartment(npData?.department)?.map((item, index) => {
																		return (
																			<option key={index} value={item?.value}>
																				{currentLang === 'kh' ? item?.labelKh : item?.label}
																			</option>
																		);
																	})}
																</Select>
															}
														/>
														<LabelDetail
															mb={1}
															mt={2}
															labelWidth={LABEL_WIDTH}
															direction="row"
															label="Type"
															childDetail={
																<>
																	{isAssistant(user?.role) || isAdmin(user?.role) ? (
																		<>
																			{npData?.completedAt ? (
																				<>
																					{npData?.doneFile ? (
																						<Tooltip label={t('Completed by done file')}>
																							<Badge colorScheme="green">{t(npData?.type)}</Badge>
																						</Tooltip>
																					) : (
																						<Tooltip label={t('Completed by step')}>
																							<Badge colorScheme="purple">{t(npData?.type)}</Badge>
																						</Tooltip>
																					)}
																				</>
																			) : (
																				<Badge>{t(npData?.type)}</Badge>
																			)}
																		</>
																	) : (
																		<Badge>{t(npData?.type)}</Badge>
																	)}
																	{npData?.isDepartmentLevel && <Badge ml={2}>{t('Department Level')}</Badge>}
																</>
															}
														/>
														{npData?.proposalNumber && (
															<LabelDetail
																mb={1}
																mt={2}
																labelWidth={LABEL_WIDTH}
																direction="row"
																label="Proposal Number"
																childDetail={
																	<HStack>
																		<ProposalNumberLink proposalNumber={npData?.proposalNumber} />
																		<FontAwesomeIcon
																			icon={faEye}
																			style={{ fontSize: 14, color: '#3498DA', cursor: 'pointer' }}
																			onClick={detailModal?.onOpen}
																		/>
																	</HStack>
																}
															/>
														)}
														{npData?.completedAt && (
															<LabelDetail
																mb={1}
																mt={2}
																labelWidth={LABEL_WIDTH}
																direction="row"
																label="Done At"
																childDetail={<LabelDate input={npData?.completedAt} outputFormat={c.dateTimeFormat} />}
															/>
														)}
														{isShowingDoneFile && (
															<LabelDetail
																mb={1}
																mt={2}
																labelWidth={LABEL_WIDTH}
																direction="row"
																label="Done"
																childDetail={<DoneFile npId={npData?.id} doneFile={npData?.doneFile} onCallback={loadNp} />}
																guide={<DoneFileTip />}
															/>
														)}
													</SimpleGrid>
													<LabelDetail
														mb={1}
														mt={0}
														labelWidth={LABEL_WIDTH}
														direction="row"
														label="Tag"
														hoverBgColor="#FFFFFF00"
														childDetail={
															<TagViewer
																id={id}
																tags={npData?.taggings?.map((tagging) => tagging?.tag?.name)}
																onCallback={loadNp}
																onTagClick={(tag) => {
																	let url = '?page=1';
																	const tags = encodeURIComponent(JSON.stringify([tag]));
																	url = url + '&tags=' + tags;
																	push('/note-of-presentation/list' + url);
																}}
															/>
														}
													/>
													<Tabs variant="enclosed" index={defaultTabIndex} onChange={setDefaultTabIndex} mt={4}>
														<TabList>
															<Tab _focus={{ boxShadow: 'none' }}>{t(mappingType[type])}</Tab>
															<Tab _focus={{ boxShadow: 'none' }}>{t('Reviewer/Preparer')}</Tab>
															<Tab _focus={{ boxShadow: 'none' }}>{t('Decision')}</Tab>
															{npData?.relation ? (
																<Tab _focus={{ boxShadow: 'none' }}>{t('COMMENT')}</Tab>
															) : (
																<>
																	{npData?.type === np && (
																		<Menu>
																			<MenuButton
																				my={2}
																				mx={2}
																				px={2}
																				cursor="pointer"
																				transition="all 0.2s"
																				borderRadius="md"
																				borderWidth="1px"
																				_hover={{ bg: 'gray.200' }}
																				_expanded={{ bg: 'gray.200' }}
																				_focus={{ boxShadow: 'none' }}
																			>
																				<FaChevronDown style={{ fontSize: 11 }} />
																			</MenuButton>
																			<MenuList pt="4" pb="4" pl="3" pr="3" borderRadius={c.borderRadius}>
																				<MenuItem
																					icon={<FaLink />}
																					onClick={() => {
																						createNpRelation({ variables: { npId: id } })
																							.then(({ data }) => {
																								setNpData(data?.createNpRelation);
																								setDefaultTabIndex(3);
																							})
																							.catch((error) => {
																								toast({
																									title: t(
																										error?.message
																											? error?.message
																											: 'something went wrong',
																									),
																									status: 'error',
																									isClosable: true,
																									position: 'bottom-right',
																								});
																							});
																					}}
																				>
																					{t('CREATE COMMENT')}
																				</MenuItem>
																			</MenuList>
																		</Menu>
																	)}
																</>
															)}
														</TabList>
														<TabPanels>
															<TabPanel borderWidth={1} borderStyle="solid" borderColor="gray.200">
																<NPEditor detail={npData} onChange={loadNp} />
															</TabPanel>
															<TabPanel borderWidth={1} borderStyle="solid" borderColor="gray.200">
																<SimpleGrid columns={[1, null, 2]} spacingX={8}>
																	<LabelDetail
																		mb={1}
																		mt={0}
																		labelWidth={LABEL_WIDTH}
																		direction="row"
																		label="Created By"
																		titleDetail={npData?.createdByUser?.fullNameKhmer}
																	/>
																	<LabelDetail
																		mb={1}
																		mt={0}
																		labelWidth={LABEL_WIDTH}
																		direction="row"
																		label="Created At"
																		childDetail={moment(npData?.createdAt)?.format('LLLL')}
																	/>
																</SimpleGrid>
																<Flex mt="8">
																	<LabelDetail
																		mb={1}
																		mt={0}
																		labelWidth={LABEL_WIDTH}
																		direction="row"
																		label="REVIEWER"
																		childDetail={
																			<Wrap>
																				{npData?.viewers?.map((item, index) => (
																					<Flex
																						direction="column"
																						justifyContent="center"
																						alignItems="center"
																						key={'u-' + index}
																					>
																						<Tooltip
																							label={
																								<>
																									{t('Assign By')}&nbsp;
																									<UserDislayNameById id={item?.createdBy} />
																									&nbsp;{', '}&nbsp;
																									{moment(item.createdAt).format('LLLL')}
																								</>
																							}
																						>
																							<WrapItem className="avatarWraper">
																								{(user?.role === 'admin' || user?.id === item?.createdBy) && (
																									<FontAwesomeIcon
																										onClick={() => {
																											if (item?.userViewer?.id !== user?.id) {
																												removeViewerMutation({
																													variables: {
																														npId: id,
																														viewerId: item?.userViewer?.id,
																													},
																												});
																											} else {
																												toast({
																													title: t(`You can't remove yourself`),
																													status: 'warning',
																													isClosable: true,
																													position: 'bottom-right',
																												});
																											}
																										}}
																										className="remove"
																										icon={faMinusSquare}
																										style={{
																											fontSize: 18,
																											display: 'none',
																											position: 'absolute',
																											zIndex: '100',
																											marginLeft: 32,
																											color: 'red',
																											backgroundColor: 'white',
																											padding: 2,
																											cursor: 'pointer',
																										}}
																									/>
																								)}
																								<Avatar
																									name={item?.userViewer?.fullNameKhmer}
																									src={
																										item?.userViewer?.avatar?.icon
																											? c.baseFilePath + item?.userViewer?.avatar?.icon
																											: null
																									}
																								/>
																							</WrapItem>
																						</Tooltip>
																						<Text textAlign="center">{item?.userViewer?.fullNameKhmer}</Text>
																					</Flex>
																				))}
																				<Flex>
																					<Button
																						className="hidden-print"
																						onClick={() => setOpenSelectUserAllModel('viewer')}
																						mt={2}
																						leftIcon={
																							<FontAwesomeIcon icon={faPlusSquare} style={{ fontSize: 18 }} />
																						}
																						colorScheme="blue"
																						variant="outline"
																						isLoading={loadingAddViewer}
																					>
																						{t('Add')}
																					</Button>
																				</Flex>
																			</Wrap>
																		}
																	/>
																</Flex>
																<Box mt="32px">
																	<Accordion allowMultiple>
																		<AccordionItem>
																			<h2>
																				<AccordionButton>
																					<Box
																						as="span"
																						flex="1"
																						textAlign="left"
																						marginLeft="-15px"
																						fontSize="14px"
																						fontWeight="bold"
																					>
																						{t('Timeline')}
																					</Box>
																					<AccordionIcon />
																				</AccordionButton>
																			</h2>
																			<AccordionPanel pb={4}>
																				<Box mt="8px">
																					<table style={{ width: '100%' }}>
																						{npData?.timelines?.map((item, index) => {
																							return (
																								<Tr key={index} _hover={{ bg: 'gray.100' }}>
																									<Td
																										w={currentLang === 'en' ? '135px' : '190px'}
																										borderRight="1px solid black"
																									>
																										<Text mr="8px">
																											{moment(item?.createdAt).format(
																												c.excelDateTimeFormat,
																											)}
																										</Text>
																									</Td>
																									<Td>
																										<Flex ml="8px" flex="1" alignItems="center">
																											<Text>
																												<span style={{ color: '#3498db' }}>
																													{item?.user?.fullNameKhmer}
																												</span>{' '}
																												&nbsp;
																												<>{getActionDetail(item)}</>
																											</Text>
																										</Flex>
																									</Td>
																								</Tr>
																							);
																						})}
																					</table>
																				</Box>
																			</AccordionPanel>
																		</AccordionItem>
																	</Accordion>
																</Box>
															</TabPanel>
															<TabPanel borderWidth={1} borderStyle="solid" borderColor="gray.200">
																{npSigns?.map(({ data: signData, position }, index) => {
																	return (
																		<Flex
																			key={index}
																			hidden={reportRoleOut(position)}
																			border="1px solid #ecf0f1"
																			p="4"
																			mb="10px"
																			direction="column"
																			textAlign={{ sm: 'center', md: 'start' }}
																		>
																			<Text fontWeight="bold" textAlign={{ base: 'center', md: 'start' }}>
																				{t(position)}
																			</Text>
																			<LabelDetail
																				mb={1}
																				mt={3}
																				labelWidth={LABEL_WIDTH}
																				direction="row"
																				responsive={true}
																				label={labelReviewer(type, position)}
																				childDetail={
																					signData?.reviewer ? (
																						<Box
																							display="flex"
																							alignItems="center"
																							justifyContent={{ base: 'center', md: 'flex-start' }}
																						>
																							<Flex direction="column" mt={2} alignItems={{ base: 'center' }}>
																								<Tooltip
																									label={
																										<>
																											{t('Assign By')}&nbsp;
																											<UserDislayNameById id={signData?.createdBy} />
																											&nbsp;{', '}&nbsp;
																											{moment(signData?.createdAt).format('LLLL')}
																										</>
																									}
																								>
																									<WrapItem className="avatarWraper">
																										{canRemoveReviewer(
																											signData?.userCreatedBy?.id,
																											signData?.userReviewer?.id,
																											signData?.decisionAt,
																											signData?.miscellaneous,
																											position,
																										) && (
																											<FontAwesomeIcon
																												onClick={() =>
																													removeReviewer({
																														variables: { id: signData?.id },
																													})
																												}
																												className="remove"
																												icon={faMinusSquare}
																												style={{
																													fontSize: 18,
																													display: 'none',
																													position: 'absolute',
																													zIndex: '100',
																													marginLeft: 32,
																													color: 'red',
																													backgroundColor: 'white',
																													padding: 2,
																													cursor: 'pointer',
																												}}
																											/>
																										)}
																										<Avatar
																											name={signData?.userReviewer?.fullNameKhmer}
																											src={
																												signData?.userReviewer?.avatar?.icon
																													? c.baseFilePath +
																														signData?.userReviewer?.avatar?.icon
																													: null
																											}
																										/>
																									</WrapItem>
																								</Tooltip>
																								<Text textAlign={{ base: 'center', md: 'start' }}>
																									{signData?.userReviewer?.fullNameKhmer}
																								</Text>
																							</Flex>
																						</Box>
																					) : (
																						<>
																							<SimpleGrid spacing={2} w={{ base: '100%', md: '10%' }}>
																								<Box h="100%" display="flex" justifyContent="center" />
																								<Box display="flex" justifyContent="center">
																									<Button
																										w={{ sm: '100px', md: '120px' }}
																										className="hidden-print"
																										size="sm"
																										mt={{ base: 2, md: 0 }}
																										leftIcon={
																											<FontAwesomeIcon
																												icon={faPlusSquare}
																												style={{ fontSize: 18 }}
																											/>
																										}
																										colorScheme="blue"
																										variant="outline"
																										onMouseDown={() => {
																											setOpenSelectUserAllModel('assignNpSign');
																											setTempSignPosition(position);
																										}}
																									>
																										{t('Select')}
																									</Button>
																								</Box>
																							</SimpleGrid>
																						</>
																					)
																				}
																			/>
																			{(signData?.decisionAt ||
																				(signData?.userReviewer && user?.id === signData?.userReviewer?.id)) && (
																				<LabelDetail
																					hoverBgColor="white"
																					mb={1}
																					mt={0}
																					responsive={true}
																					labelWidth={LABEL_WIDTH}
																					direction="row"
																					label={t('Sign')}
																					childDetail={
																						signData?.decisionAt ? (
																							<>
																								{/* signData */}
																								<WrapItem className="avatarWraper">
																									{canRemoveSigning(signData?.userReviewer?.id, position) && (
																										<FontAwesomeIcon
																											onClick={() => {
																												removeSignNp({
																													variables: {
																														signId: signData?.id,
																													},
																												});
																											}}
																											className="remove"
																											icon={faMinusSquare}
																											style={{
																												fontSize: 18,
																												display: 'none',
																												position: 'absolute',
																												zIndex: '100',
																												marginLeft: 4,
																												marginTop: 18,
																												color: 'red',
																												backgroundColor: 'white',
																												padding: 2,
																												cursor: 'pointer',
																											}}
																										/>
																									)}
																									<Box
																										w="100%"
																										mt="4"
																										borderRadius={c.borderRadius}
																										border="1px solid #bdc3c7"
																										p="2"
																									>
																										<Center fontSize="md" mb={2}>
																											{moment(signData?.decisionAt).format('LLLL')}
																										</Center>
																										{signData?.decision?.decision && (
																											<Center>
																												<Text
																													whiteSpace="pre-line"
																													color={c.penColor}
																													fontWeight="bold"
																													fontSize="md"
																													textAlign="center"
																													mb={2}
																												>
																													{signData?.decision?.decision}
																												</Text>
																											</Center>
																										)}
																										<Center mb={2} fontWeight="bold" fontSize="md">
																											{signData?.decision?.title}
																										</Center>
																										<Center mb={8} fontWeight="bold" fontSize="md">
																											{signData?.decision?.unit}
																										</Center>
																										{signData?.decisionFile ? (
																											<Center mb={8}>
																												<Image
																													w="260px"
																													h="390px"
																													src={signData?.decisionFile}
																												/>
																											</Center>
																										) : (
																											<>
																												<Center mb={8}>
																													{signData?.signatureImage?.file && (
																														<Image
																															w="240px"
																															h="135px"
																															maxW="240px"
																															maxH="135px"
																															minW="240px"
																															minH="135px"
																															src={signData?.signatureImage?.file}
																															pointerEvents="none"
																														/>
																													)}
																												</Center>
																												<Center
																													mb={4}
																													fontWeight="bold"
																													fontSize="md"
																													color={c.penColor}
																												>
																													{signData?.userReviewer?.fullNameKhmer}
																												</Center>
																											</>
																										)}
																										<Flex justifyContent="flex-end" alignItems="center">
																											<SmallDownloadAndViewButton
																												url={signData?.decision?.attachment?.file}
																												size={signData?.decision?.attachment?.fileSize}
																											/>
																										</Flex>
																									</Box>
																								</WrapItem>
																							</>
																						) : (
																							<>
																								{signData?.userReviewer && (
																									<>
																										{/* Since miscellaneous is hidden, this condition will never be true */}
																										{/* Since miscellaneous is hidden, this condition will never be true */}
																										{/* Since miscellaneous is hidden, this condition will never be true */}
																										{signData?.miscellaneous ? (
																											<WrapItem className="avatarWraper">
																												{canRemoveMiscellaneous(
																													signData?.userReviewer?.id,
																													signData?.miscellaneous?.createdBy,
																													position,
																												) && (
																													<FontAwesomeIcon
																														onClick={() => {
																															removeSignNpMisc({
																																variables: {
																																	signId: signData?.id,
																																},
																															})
																																.then(({ data }) => loadNp())
																																.catch((error) => {
																																	if (
																																		error?.graphQLErrors
																																			?.length > 0
																																	) {
																																		error?.graphQLErrors.map(
																																			({ message }, i) =>
																																				toast({
																																					title: t(
																																						message,
																																					),
																																					status: 'error',
																																					isClosable: true,
																																					position:
																																						'bottom-right',
																																				}),
																																		);
																																	} else {
																																		toast({
																																			title: t(
																																				error?.message
																																					? error?.message
																																					: 'something went wrong',
																																			),
																																			status: 'error',
																																			isClosable: true,
																																			position:
																																				'bottom-right',
																																		});
																																	}
																																});
																														}}
																														className="remove"
																														icon={faMinusSquare}
																														style={{
																															fontSize: 18,
																															display: 'none',
																															position: 'absolute',
																															zIndex: '100',
																															marginLeft: 4,
																															marginTop: 18,
																															color: 'red',
																															backgroundColor: 'white',
																															padding: 2,
																															cursor: 'pointer',
																														}}
																													/>
																												)}
																												<Flex
																													mt="4"
																													minWidth="340px"
																													borderRadius={c.borderRadius}
																													justifyContent="flex-start"
																													alignItems="center"
																													border="1px solid #bdc3c7"
																													p="2"
																												>
																													{signData?.miscellaneous?.description && (
																														<Text
																															mb={2}
																															color={c.penColor}
																															fontWeight="bold"
																															fontSize="md"
																															textAlign="left"
																														>
																															{
																																signData?.miscellaneous
																																	?.description
																															}
																														</Text>
																													)}
																													<Flex
																														justifyContent="flex-end"
																														alignItems="center"
																													>
																														<SmallDownloadAndViewButton
																															url={
																																signData?.miscellaneous
																																	?.attachment?.file
																															}
																															size={
																																signData?.miscellaneous
																																	?.attachment?.fileSize
																															}
																														/>
																													</Flex>
																												</Flex>
																											</WrapItem>
																										) : (
																											<Flex
																												justifyContent="flex-start"
																												alignItems="center"
																											>
																												{user?.id === signData?.userReviewer?.id && (
																													<Button
																														w="120px"
																														mt={2}
																														mr={2}
																														size="sm"
																														leftIcon={
																															<FontAwesomeIcon
																																icon={faFileSignature}
																																style={{ fontSize: 18 }}
																															/>
																														}
																														colorScheme="blue"
																														onMouseDown={() => {
																															if (
																																user?.id ===
																																signData?.userReviewer?.id
																															) {
																																setActiveSignData({
																																	...signData,
																																	canComment:
																																		canComment(position),
																																	canDelegate:
																																		canDelegate(position),
																																	labelComment:
																																		getLabelComment(
																																			position,
																																		),
																																});
																															} else {
																																toast({
																																	title: t('NOT_ALLOWED'),
																																	status: 'warning',
																																	isClosable: true,
																																	position: 'bottom-right',
																																});
																															}
																														}}
																													>
																														{t('Sign')}
																													</Button>
																												)}
																												{/* Hide miscellaneous button */}
																												{/* Hide miscellaneous button */}
																												{/* Hide miscellaneous button */}
																												{[3, 4]?.includes(
																													mappingPosition[position],
																												) && (
																													<Button
																														w="120px"
																														mt={2}
																														mr={0}
																														size="sm"
																														hidden={true}
																														leftIcon={
																															<FontAwesomeIcon
																																icon={faPlusSquare}
																																style={{ fontSize: 18 }}
																															/>
																														}
																														colorScheme="blue"
																														onMouseDown={() =>
																															setActiveSignDataMisc(signData)
																														}
																													>
																														{t('Miscellaneous')}
																													</Button>
																												)}
																												{/* Hide miscellaneous button */}
																												{/* Hide miscellaneous button */}
																												{/* Hide miscellaneous button */}
																											</Flex>
																										)}
																									</>
																								)}
																							</>
																						)
																					}
																				/>
																			)}
																		</Flex>
																	);
																})}
															</TabPanel>
															{npData?.relation && (
																<TabPanel borderWidth={1} borderStyle="solid" borderColor="gray.200">
																	<Flex justifyContent="flex-start" alignItems="flex-start">
																		<Box width="100%">
																			<Box width="100%">
																				<DepartmentUserAssign
																					permission="companySubmissionProposal"
																					departments={npData?.relation?.departments}
																					assignees={npData?.viewers?.map((e) => e?.userViewer)}
																					onSelectCallback={(department) => {
																						appendDepartmentToNpRelation({
																							variables: {
																								relationId: npData?.relation?.id,
																								department,
																								npId: npData?.id,
																							},
																						})
																							.then(({ data }) => loadNp())
																							.catch((error) => {
																								toast({
																									title: t(
																										error?.message
																											? error?.message
																											: 'something went wrong',
																									),
																									status: 'error',
																									isClosable: true,
																									position: 'bottom-right',
																								});
																							});
																					}}
																					onRemoveCallback={(department) => {
																						removeDepartmentFromNpRelation({
																							variables: {
																								relationId: npData?.relation?.id,
																								department,
																								npId: npData?.id,
																							},
																						})
																							.then(({ data }) => loadNp())
																							.catch((error) => {
																								toast({
																									title: t(
																										error?.message
																											? error?.message
																											: 'something went wrong',
																									),
																									status: 'error',
																									isClosable: true,
																									position: 'bottom-right',
																								});
																							});
																					}}
																				/>
																			</Box>
																			<Box width="100%" mt={4}>
																				<OfficeUserAssign
																					permission="companySubmissionProposal"
																					offices={npData?.relation?.offices}
																					assignees={npData?.viewers?.map((e) => e?.userViewer)}
																					onSelectCallback={(office) => {
																						appendOfficeToNpRelation({
																							variables: {
																								relationId: npData?.relation?.id,
																								office,
																								npId: npData?.id,
																							},
																						})
																							.then(({ data }) => loadNp())
																							.catch((error) => {
																								toast({
																									title: t(
																										error?.message
																											? error?.message
																											: 'something went wrong',
																									),
																									status: 'error',
																									isClosable: true,
																									position: 'bottom-right',
																								});
																							});
																					}}
																					onRemoveCallback={(office) => {
																						removeOfficeFromNpRelation({
																							variables: {
																								relationId: npData?.relation?.id,
																								office,
																								npId: npData?.id,
																							},
																						})
																							.then(({ data }) => loadNp())
																							.catch((error) => {
																								toast({
																									title: t(
																										error?.message
																											? error?.message
																											: 'something went wrong',
																									),
																									status: 'error',
																									isClosable: true,
																									position: 'bottom-right',
																								});
																							});
																					}}
																				/>
																			</Box>
																			<Box width="100%" mt={4}>
																				<Relation
																					relationId={npData?.relation?.id}
																					excludedNpIds={[npData?.id]}
																					changedStep={npData?.step}
																					onChange={() => loadNp()}
																				/>
																			</Box>
																		</Box>
																		{npData?.relation?.relations?.length <= 0 && (
																			<Box ml={2}>
																				<RelationDeletion
																					relationId={npData?.relation?.id}
																					onComplete={(np) => {
																						setNpData(np);
																						setDefaultTabIndex(0);
																					}}
																				/>
																			</Box>
																		)}
																	</Flex>
																</TabPanel>
															)}
														</TabPanels>
													</Tabs>
												</>
											)}
										</Box>
									</Box>
								</Center>
								<Box className="show-only-printing" width="100%">
									<Print type={type} npData={npData} npSigns={npSigns} />
								</Box>
								<Box className="hidden-print" width="100%">
									<ViewComment id={id} type={'NP'} />
								</Box>
							</Container>
							<AlertDialog
								closeOnEsc={!loadingDeleteNp}
								closeOnOverlayClick={!loadingDeleteNp}
								isOpen={modalDeleteNp?.isOpen}
								onClose={modalDeleteNp?.onClose}
							>
								<AlertDialogOverlay>
									<AlertDialogContent>
										<AlertDialogHeader fontSize="lg" fontWeight="bold">
											{t('Delete')}
										</AlertDialogHeader>
										<AlertDialogBody>{t("Are you sure? You can't undo this action afterwards")}</AlertDialogBody>
										<AlertDialogFooter>
											<Button onMouseDown={modalDeleteNp?.onClose}>{t('Cancel')}</Button>
											<Button
												ml={4}
												isLoading={loadingDeleteNp}
												colorScheme="red"
												onClick={() => {
													deleteNp({ variables: { npId: id } })
														.then(({ data }) => push('/note-of-presentation/list?page=1'))
														.catch((error) => {
															toast({
																title: t(error?.message ? error?.message : 'something went wrong'),
																status: 'error',
																isClosable: true,
																position: 'bottom-right',
															});
														});
												}}
											>
												{t('Delete')}
											</Button>
										</AlertDialogFooter>
									</AlertDialogContent>
								</AlertDialogOverlay>
							</AlertDialog>

							{activeSignData && (
								<SignNpModal
									signData={activeSignData}
									onClose={() => setActiveSignData(null)}
									onComplete={(result) => {
										setActiveSignData(null);
										loadNp();
									}}
								/>
							)}

							{activeSignDataMisc && (
								<SignMiscModal
									signData={activeSignDataMisc}
									onClose={() => setActiveSignDataMisc(null)}
									onComplete={(result) => {
										setActiveSignDataMisc(null);
										loadNp();
									}}
								/>
							)}

							{openSelectUserAllModel && (
								<SelectUserAllModal
									onClose={() => setOpenSelectUserAllModel(false)}
									callback={(e) => {
										if (openSelectUserAllModel === 'viewer') {
											setOpenSelectUserAllModel(false);
											addViewerMutation({
												variables: {
													npId: id,
													viewerId: e?.id,
												},
											});
										}

										if (openSelectUserAllModel === 'assignNpSign') {
											if (tempSignPosition && e?.id && id) {
												assignNpSign({
													variables: {
														position: tempSignPosition,
														reviewerId: e?.id,
														npId: id,
													},
												})
													.then(({ data }) => {
														loadNp();
													})
													.catch((error) => {
														toast({
															title: t(error?.message ? error?.message : 'something went wrong'),
															status: 'error',
															isClosable: true,
															position: 'bottom-right',
														});
													});
											} else {
												toast({
													title: t('something went wrong'),
													status: 'error',
													isClosable: true,
													position: 'bottom-right',
												});
											}
											setOpenSelectUserAllModel(false);
											setTempSignPosition(null);
										}
									}}
									viewType="all"
								/>
							)}

							{stepBack && (
								<StepBackModal
									step={stepBack}
									onClose={() => setStepBack(null)}
									onComplete={(e) => {
										changeStepMutation({ variables: { npId: id, step: e?.step, comments: e?.comments } })
											.then(({ data }) => {
												setNpData(data?.changeNpStep);
												loadNpSigns();
											})
											.catch((error) => {
												toast({
													title: t(error?.message ? error?.message : 'something went wrong'),
													status: 'error',
													isClosable: true,
													position: 'bottom-right',
												});
											});
									}}
								/>
							)}

							{detailModal?.isOpen && <ProposalDetailModal id={npData?.proposal?.id} onCloseModal={detailModal?.onClose} />}
						</>
					</ModalBody>
				</ModalContent>
			</Modal>
		</>
	);
}

const queryNpDetail = `
	id
	createdBy
	createdAt
	step
	number
	subject
    references
    description
    attachments
    attachings
    proposalNumber
    doneFile
    allowAddingOtherAttachments
    type
	office
	department
    completedAt
    urgent
	createdByUser {
		id
		username
		fullName
		fullNameKhmer
		avatar
        position
        office
	    department
	}
	viewers {
		id
		createdAt
		createdBy
		userViewer{
			id
			username
			fullName
			fullNameKhmer
			avatar
            department
            office
		}
	}
	timelines {
		id
		createdAt
		user{
			id
			username
			fullName
			fullNameKhmer
		}
		action
		description
	}
    proposal {
        id
        no
    }
    checkInAt
    checkOutAt
    checkInDdgAt
    checkInDgAt
	assistantColor
    isDepartmentLevel
    relation {
        id
        np {
            id
            number
            subject
            step
        }
        offices
        departments
        relations {
            id
            number
            subject
            step
        }
        createdAt
        updatedAt
        deleted
    }
    taggings {
		id
		npId
		tag {
			id
			createdAt
			createdBy
			name
		}
	}
`;

const Q_GET_REQUESTS = gql`
	query get($id: String!) {
		getNpById(id: $id) {
			${queryNpDetail}
		}
	}
`;

const ADD_VIEWER_MUTATION = gql`
	mutation assignViewerToNp($npId: String!, $viewerId: String!) {
		assignViewerToNp(npId: $npId, viewerId: $viewerId) {
			id
			createdAt
			createdBy
			userViewer {
				id
				username
				fullName
				fullNameKhmer
				avatar
			}
		}
	}
`;

const REMOVE_VIEWER_MUTATION = gql`
	mutation removeViewerToNp($npId: String!, $viewerId: String!) {
		removeViewerFromNp(npId: $npId, viewerId: $viewerId)
	}
`;

const CHANGE_STEP_MUTATION = gql`
    mutation changeNpStep($npId: String!, $step: String!, $comments: String){
        changeNpStep(npId: $npId, step: $step, comments: $comments){
			${queryNpDetail}
		}
    }
`;

const CHANGE_DEPARTMENT_MUTATION = gql`
    mutation changeNpDepartment($npId: String!, $department: String!){
        changeNpDepartment(npId: $npId, department: $department){
			${queryNpDetail}
		}
    }
`;

const CHANGE_OFFICE_MUTATION = gql`
    mutation changeNpOffice($npId: String!, $office: String!){
        changeNpOffice(npId: $npId, office: $office){
			${queryNpDetail}
		}
    }
`;

const queryNpSignsDetail = `
	id
	createdAt
	userCreatedBy{
		id
		username
		fullName
		fullNameKhmer
		avatar
	}
	createdBy
	position
	reviewer
	userReviewer{
		id
		username
		fullName
		fullNameKhmer
		avatar
        role
        position
        office
        department
	}
	decision
	decisionAt
	signature
    signatureImage
    miscellaneous
	decisionFile
`;

const ASSIGN_NP_SIGN_MUTATION = gql`
    mutation assign($npId: String!, $reviewerId: String!, $position: String!){
        assignNpReviewer(npId: $npId,reviewerId: $reviewerId,position: $position){
			${queryNpSignsDetail}
		}
    }
`;

const GET_NP_SIGNS = gql`
    query getNpSign($id: String!){
        getNpSigns(id: $id){
			${queryNpSignsDetail}
		}
    }
`;

const REMOVE_REVIEWER_MUTATION = gql`
    mutation removeReviewer($id: String!){
        removeReviewer(id: $id){
			${queryNpSignsDetail}
		}
    }
`;

const REMOVE_SIGN_NP_MUTATION = gql`
    mutation removeSignNp($signId: String!){
        removeSignNp(signId: $signId){
			${queryNpSignsDetail}
		}
    }
`;

const REMOVE_SIGNNP_MISC_MUTATION = gql`
    mutation removeSignNpMiscellaneous($signId: String!){
        removeSignNpMiscellaneous(signId: $signId){
			${queryNpSignsDetail}
		}
    }
`;

const M_DELETE_NP = gql`
	mutation deleteNp($npId: String!) {
		deleteNp(npId: $npId)
	}
`;

const M_URGENT_NP = gql`
	mutation setNpUrgent($npId: String!, $urgent: Boolean!) {
		setNpUrgent(npId: $npId, urgent: $urgent) {
            ${queryNpDetail}
        }
	}
`;

const M_A_COLOR_NP = gql`
	mutation setNpColor($npId: String!, $color: String!) {
		setNpColor(npId: $npId, color: $color) {
            ${queryNpDetail}
        }
	}
`;

const M_CREATE_RELATION = gql`
	mutation createNpRelation($npId: String!) {
		createNpRelation(npId: $npId) {
            ${queryNpDetail}
        }
	}
`;

const M_ADD_DEPARTMENT_RELATION = gql`
	mutation appendDepartmentToNpRelation($relationId: String!, $department: JSON!, $npId: String) {
		appendDepartmentToNpRelation(relationId: $relationId, department: $department, npId: $npId)
	}
`;

const M_REMOVE_DEPARTMENT_RELATION = gql`
	mutation removeDepartmentFromNpRelation($relationId: String!, $department: JSON!, $npId: String) {
		removeDepartmentFromNpRelation(relationId: $relationId, department: $department, npId: $npId)
	}
`;

const M_ADD_OFFICE_RELATION = gql`
	mutation appendOfficeToNpRelation($relationId: String!, $office: JSON!, $npId: String) {
		appendOfficeToNpRelation(relationId: $relationId, office: $office, npId: $npId)
	}
`;

const M_REMOVE_OFFICE_RELATION = gql`
	mutation removeOfficeFromNpRelation($relationId: String!, $office: JSON!, $npId: String) {
		removeOfficeFromNpRelation(relationId: $relationId, office: $office, npId: $npId)
	}
`;

export default NpReferenceDetailModal;
